import { get } from "@ember/object"
import Route from "@ember/routing/route"
import { later } from "@ember/runloop"
import { inject as service } from "@ember/service"
import { isNone } from "@ember/utils"
import planbookViewAction from "cc-frontend/lib/actions/app-state/PLANBOOK_VIEW"
import { includes } from "lodash-es"

export default class ApplicationRoute extends Route {
  queryParams = { token: { replace: true } }

  @service dispatcher
  @service presence
  @service headData

  activate() {
    this.router.on("routeDidChange", (transition) => {
      if (
        includes(transition.to.name, "planbookv5") &&
        transition.to.attributes?.planbook?.id !== undefined &&
        !transition.to.name.includes("index") &&
        transition.to.name !== transition.from?.name
      ) {
        let queryParams = transition.to.queryParams || {}
        this.dispatcher.dispatchPreparedAction(
          planbookViewAction({
            routeName: transition.to.name,
            planbookId: transition.to.attributes.planbook.id,
            queryParams: queryParams,
          })
        )
      }

      if (
        includes(transition.to.name, "planbookv5.planner") &&
        transition.to.attributes?.planbook?.id !== undefined
      ) {
        // save last used view settings in local storage
        this.sessionStore.persistObject(
          `planbook-${transition.to.attributes.planbook.id}-lastView`,
          {
            url: `${this.router.currentURL}`,
            route: `${transition.to.name}`,
            queryParams: transition.to.queryParams,
          }
        )

        // Set presence to the current planbook.
        this.presence.setPlanbookId(transition.to.attributes.planbook.id)
      } else {
        // Unset presence.
        this.presence.setPlanbookId(null)
      }
    })
  }

  @service
  router

  @service
  session

  @service
  socket

  @service
  finder

  @service
  query

  @service
  sessionStore

  init() {
    super.init(...arguments)
    this.token = null

    if (window && typeof window.addEventListener === "function") {
      window.addEventListener("storage", (e) => {
        if (e.key === "signOutNow") {
          this.transitionTo("user.sign-out")
        }
      })
    }

    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    if (vw < 649) {
      document.body.className += " less-than-649px"
    }
  }

  model(params, transition) {
    this.headData.robots = "all"

    let queryParams = transition.to.queryParams || {}
    if (!isNone(queryParams.token)) {
      later(() => {
        return this.transitionTo({ queryParams: { token: null } })
      }, 1000)
    }
    if (queryParams.promotionCode) {
      get(this, "sessionStore").persistObject("promotionCode", {
        promotionCode: queryParams.promotionCode,
      })
    }
    // Held until they upgrade: teachers land on a promotion link, sign up, and only
    // reach the upgrade buttons later. Dropped from the URL once stored, the same way
    // `token` above is — it is an application-level query param, so it would otherwise
    // ride along every transition, get copied into shared links, and re-persist itself
    // on the reload that follows a successful upgrade.
    if (queryParams.coupon) {
      get(this, "sessionStore").persistObject("coupon", { coupon: queryParams.coupon })
      later(() => {
        return this.transitionTo({ queryParams: { coupon: null } })
      }, 1000)
    }
  }
}
